<template>
  <b-form @submit.prevent="onSubmit">

    <b-form-group :label="$t('Name')" label-for="name">
      <b-form-input id="name" v-model="planData.name" autofocus :state="errors && ('name' in errors) ? false : null"
        trim autocomplete="off" placeholder="" />
      <b-form-invalid-feedback v-if="errors && ('name' in errors)" :state="errors && ('name' in errors) ? false : null">
        {{ errors.name[0] }}
      </b-form-invalid-feedback>
    </b-form-group>

    <!-- device -->
    <b-form-group :label="$t('Device')" label-for="device" :state="null">

      <v-select v-model="planData.device_id" label="name" :reduce="val => val.device_id"
        :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'" :options="devicesOptions" :clearable="true"
        input-id="device" @input="set_name($event), refilterAreas()" />

      <b-form-invalid-feedback v-if="errors && ('device_id' in errors)"
        :state="errors && ('device_id' in errors) ? false : null">
        {{ errors.device_id[0] }}
      </b-form-invalid-feedback>
    </b-form-group>


    <!-- Work -->
    <b-form-group :label="$t('path')" label-for="route" :state="null">
      <v-select v-model="planData.route" label="name"  :close-on-select="false"
        :reduce="val => val.geofence_id" :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'"
        :options="workAreasOptions_org" 
        :selectable="(option) => workAreasOptions.includes(option)"
        :clearable="false" input-id="route" />
      <b-form-invalid-feedback v-if="errors && ('route' in errors)"
        :state="errors && ('route' in errors) ? false : null">
        {{ errors.route[0] }}
      </b-form-invalid-feedback>
    </b-form-group>

    <!-- Camp -->
    <b-form-group :label="$t('Camp')" label-for="camp" :state="null">
      <v-select v-model="planData.camp_id" label="name" :reduce="val => val.geofence_id"
        :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'" :options="campsOption_org" :clearable="false"
        :selectable="(option) => campsOption.includes(option)"
        input-id="camp" />
      <b-form-invalid-feedback v-if="errors && ('camp_id' in errors)"
        :state="errors && ('camp_id' in errors) ? false : null">
        {{ errors.camp_id[0] }}
      </b-form-invalid-feedback>
    </b-form-group>


    <b-row>
      <b-col cols="6">
        <!-- leave camp time -->
        <b-form-group :label="$t('Leave Camp Time')" label-for="leave-camp" :state="null">
          <flat-pickr v-model="planData.camp_leave" dateFormat="H:m:s" class="form-control"
            :class="{ 'is-invalid': errors && ('camp_leave' in errors) }" :config="flatPickerConfig"
            placeholder="HH:MM:SS" />
          <b-form-invalid-feedback v-if="errors && ('camp_leave' in errors)"
            :state="errors && ('camp_leave' in errors) ? false : null">
            {{ errors.camp_leave[0] }}
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
      <b-col cols="6">
        <!-- back camp time -->
        <b-form-group :label="$t('Back Camp Time')" label-for="back-camp" :state="null">
          <flat-pickr v-model="planData.camp_back" :state="null" class="form-control"
            :class="{ 'is-invalid': errors && ('camp_back' in errors) }" :config="flatPickerConfig"
            placeholder="HH:MM:SS" />
          <b-form-invalid-feedback v-if="errors && ('camp_back' in errors)"
            :state="errors && ('camp_back' in errors) ? false : null">
            {{ errors.camp_back[0] }}
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>   
    </b-row>

    <b-form-group :label="$t('CONTAINER_WASH_SCHEDULE_LABEL')" label-for="schedule">
      <v-select 
        :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'"
        v-model="planData.schedule" 
        label="label"
        :reduce="option => option.key"
        :options="[
          {key:'daily', label: $t('CONTAINER_WASH_SCHEDULE_DAILY_LABEL')},
          {key:'weekly', label: $t('CONTAINER_WASH_SCHEDULE_WEEKLY_LABEL')},
          {key:'monthly', label: $t('CONTAINER_WASH_SCHEDULE_MONTHLY_LABEL')},
        ]"
        />

      <b-form-invalid-feedback v-if="errors && ('schedule' in errors)"
        :state="errors && ('schedule' in errors) ? false : null">
        {{ errors.schedule[0] }}
      </b-form-invalid-feedback>
    </b-form-group>

    <b-form-group :label="$t('CONTAINER_WASH_TIMES_LABEL')" label-for="times">
      <b-form-input id="times" v-model="planData.times" :state="errors && ('times' in errors) ? false : null"
        trim type='number'/>

      <b-form-invalid-feedback v-if="errors && ('times' in errors)"
        :state="errors && ('times' in errors) ? false : null">
        {{ errors.schedule[0] }}
      </b-form-invalid-feedback>
    </b-form-group>

    <b-form-group :label="$t('CONTAINER_WASH_COUNT_LABEL')" label-for="containers_count">
      <b-form-input id="containers_count" v-model="planData.containers_count" :state="errors && ('containers_count' in errors) ? false : null"
        trim type='number'/>

      <b-form-invalid-feedback v-if="errors && ('containers_count' in errors)"
        :state="errors && ('containers_count' in errors) ? false : null">
        {{ errors.containers_count[0] }}
      </b-form-invalid-feedback>
    </b-form-group>

    <b-row>
        <b-col cols="6">
          <b-form-group :label="$t('import from file')" label-for="containers_excl_file" :state="null">
          <b-form-file id="containers_excl_file"  ref="importFileInput" dir="ltr" @input="importFile"  :placeholder="$t('select file')" drop-placeholder="Drop file here..." />
          <b-form-invalid-feedback v-if="errors && ('containers_excl_file' in errors)"
            :state="errors && ('containers_excl_file' in errors) ? false : null">
            {{ errors.containers_excl_file[0] }}
          </b-form-invalid-feedback>
       
       </b-form-group>
        </b-col>
      </b-row>

          <b-col cols="12">
      <b-form-group :label="$t('work days')" label-for="workdays" :state="null">
        <b-form-checkbox-group
            v-model="planData.days"
            :options="daysOptions" name="flavour-1a">
        </b-form-checkbox-group>
        <b-form-invalid-feedback v-if="errors && ('days' in errors)"
                                 :state="errors && ('days' in errors) ? false : null">
          {{ errors.days[0]  }}
        </b-form-invalid-feedback>
      </b-form-group>
    </b-col>
    <!-- Form Actions -->
    <div class="d-flex mt-2">
      <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary" class="mr-2" type="submit">
        {{ $t('Save') }}
      </b-button>
    </div>
  </b-form>
</template>
  
<script>

import {
  BCol, 
  BRow, 
  BFormGroup, 
  BFormInvalidFeedback, 
  BFormRadioGroup, 
  BFormCheckboxGroup,
  BButton, 
  BForm, 
  BFormInput, 
  BFormSelect,
  BFormSelectOption,
  BFormFile

} from 'bootstrap-vue'

import AreaFormRepeater from '@/components/form/AreaFormRepeater'
import IrrigationFormRepeater from '@/components/form/IrrigationFormRepeater'
import { onUnmounted, ref } from '@vue/composition-api'
import Ripple from 'vue-ripple-directive'
import flatPickr from 'vue-flatpickr-component'
import vSelect from 'vue-select'
import store from '@/store'
import formGetLinkedOptions from '@/views/modules/api/formGetLinkedOptions'

export default {
  name: 'ContainerWashPlanForm',
  components: {
    IrrigationFormRepeater,
    BFormFile,
    AreaFormRepeater, 
    BButton, 
    BFormCheckboxGroup,
    flatPickr, 
    vSelect, 
    BForm, 
    BFormInput,
    BCol, 
    BRow, 
    BFormGroup, 
    BFormInvalidFeedback, 
    BFormRadioGroup, 
    BFormSelect, 
    BFormSelectOption
  },
  props: {
    errors: {
      type: Object | undefined,
      required: true
    },
    planData: {
      type: Object,
      required: true
    },
    onSubmit: {
      type: Function,
      required: true
    }
  },
  directives: {
    Ripple,
  },
  setup(props, {root}) {

    const importFileInput = ref(null)
    const user = store.getters['auth/user']
    const device_geofences_ids = ref()

    // Register module
    if (!store.hasModule('formOptions'))
      store.registerModule('formOptions', formGetLinkedOptions)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule('formOptions'))
        store.unregisterModule('formOptions')
    })

    const devicesOptions = ref([])

    const workAreasOptions = ref([])

    const campsOption = ref([])
    const campsOption_org = ref([])

    const workAreasOptions_org = ref([])

    const daysOptions = [
      { text: root.$t('Saturday'), value: 'Saturday' },
      { text: root.$t('Sunday'), value: 'Sunday' },
      { text: root.$t('Monday'), value: 'Monday' },
      { text: root.$t('Tuesday'), value: 'Tuesday' },
      { text: root.$t('Wednesday'), value: 'Wednesday' },
      { text: root.$t('Thursday'), value: 'Thursday' },
      { text: root.$t('Friday'), value: 'Friday' },
    ]

    const flatPickerConfig = {
      enableTime: true,
      noCalendar: true,
      time_24hr: true,
      dateFormat: "H:i:S",
    }

    const setOptions = area => {
      switch (area.category) {
        case 'WORK_AREA': workAreasOptions.value.push(area); break
        case 'CAMP_AREA': campsOption.value.push(area); break
      }
    }

    const set_name = (e) => {
      const device = devicesOptions.value.find(d => d.device_id === e)
      props.planData.name += ` - ${device.name}`
      props.planData.device_id = device.device_id
    }

    const setOriginalOptions = area => {
      switch (area.category) {
        case 'WORK_AREA': workAreasOptions_org.value.push(area); break
        case 'CAMP_AREA': campsOption_org.value.push(area); break
      }
    }

    const refilterAreas = () => {
      let d_id = props.planData.device_id
      device_geofences_ids.value = []
      store.dispatch('formOptions/getItemsLinkedTo', {
        deviceId: d_id,
        type: 'deviceGeofences',
      }).then(res => {
        //display areas that link to selected device
        device_geofences_ids.value = res.data.ids;
        workAreasOptions.value = workAreasOptions_org.value.filter((i) => device_geofences_ids.value.includes(i.geofence_id))
        campsOption.value = campsOption_org.value.filter((i) => device_geofences_ids.value.includes(i.geofence_id))
      })
    }

    store.dispatch('formOptions/getLinkedOptions', {
      user: user.id,
      type: 'geofence',
      cols: 'geofence_id,name,category'
    }).then(res => {
      res.data.data.map(a => {
        setOptions(a)
        setOriginalOptions(a)
      })
    }
    ).catch(reason => { })


    store.dispatch('formOptions/getLinkedOptions', {
      user: user.id,
      type: 'device',
      cols: 'device_id,name',
      isSupport: false,
    }).then(res => devicesOptions.value = res.data.data).catch(reason => { })


    const rangeDate = ref('')
    const pickerOptions = {
      dateFormat: 'Y-m-d H:i:S',
      defaultDate: [
        new Date().setHours(0, 0, 0),
        new Date().setHours(23, 59, 59, 59),
      ],

      enableTime: true,
      enableSeconds: true,
      defaultHour: 23,
      mode: 'range',
      time_24hr: true,
      onClose: function (selectedDates, dateStr, instance) {
        const date = dateStr.split(' to ')
        props.planData.start_date = date[0]
        props.planData.end_date = date[1]
      },
    }
    const importFile = () => {
      props.planData.containers_excl_file=importFileInput.value.files[0];
    }

    return {
      daysOptions,
      flatPickerConfig,
      pickerOptions,
      devicesOptions,
      workAreasOptions,
      workAreasOptions_org,
      campsOption,
      campsOption_org,
      device_geofences_ids,
      rangeDate,
      set_name,
      refilterAreas,
      importFileInput,
      importFile
    }

  }
}
</script>
  
<style scoped>

</style>
  